import { render } from "./NewTaskDialog.vue?vue&type=template&id=4d58a32e&scoped=true"
import script from "./NewTaskDialog.vue?vue&type=script&lang=js"
export * from "./NewTaskDialog.vue?vue&type=script&lang=js"

import "./NewTaskDialog.vue?vue&type=style&index=0&id=4d58a32e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d58a32e"]])

export default __exports__